import React from 'react'
export default class AboutBuilder extends React.Component{
    constructor(props){
        super(props)
    }
    render(){
        return(
            <div className='about-builder-main-div' id='about'>
                <div className='builder-header-main-div'>
                    <div className='builder-line'></div>
                    <div className='builder-name'>{this.props.builder_name}</div>
                    <div className='builder-line'></div>
                </div>
                <div className='builder-count-div'>
                    <div className='builder-count-inner'>
                        <div className='builder-count'>{this.props.builder_experiance}</div>
                        <div className='builder-count-text'>Year of Experience</div>
                    </div>
                    <div className='builder-count-inner'>
                    <div className='builder-count'>{this.props.builder_total}</div>
                        <div className='builder-count-text'>Total Projects</div>
                    </div>
                    <div className='builder-count-inner'>
                    <div className='builder-count'>{this.props.builder_ongoing}</div>
                        <div className='builder-count-text'>Ongoing Projects</div>
                    </div>
                </div>
                <div className='builder-desc'>
                {this.props.builder_description}
                </div>

            </div>
        )
    }
}